module.exports = __webpack_public_path__ + "static/media/default_image.b920e97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/advertisers/modules/tutorials/assets/default_image.png
// module id = ./src/advertisers/modules/tutorials/assets/default_image.png
// module chunks = 8